

<template>
  <div>
    <section id="intro">
      <div id="topo_base"></div>
      <div id="topo">
        <div class="content">
          <button v-on:click="toggleSidebar" id="toggle-sidebar-button">
            <i class="icon icon-menu-34"></i>
          </button>

          <div id="logo" class="animated fadeIn">
            <a style="font-size: 14px;">
              <img id="logo-dark-and-default-theme" src="/images/logo4.png" alt="logo" title="logo" />
            </a>
          </div>
          
          <div
            class="login-dropdown dropdown"
            v-bind:class="{ open: menuOpen}"
            v-on:click="toggleDropdown"
          >
            <span
              class="dropdown-toggle"
              type="button"
              id="dropdownMenu1"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="true"
            >
              <span class="icon icon-circle-10-2"></span>
              <span class="icon icon-stre-down"></span>
            </span>

            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
              <li class="profile-edit">
                <div class="image-content">
                  <img src="/images/placeholder-user.png" id="avatar" />
                </div>
                <div class="text-content">
                  <span>Olá, {{userName}}</span>
                  <a
                    v-on:click="loadUserPage()"
                    href="#"
                    class="edit"
                    style="font-size: 9px;"
                  >Editar perfil</a>
                </div>
              </li>

              <li class="dropdown-item">
                <a v-on:click="logout()" href="#" style="font-size: 14px;">
                  <span class="icon icon-circle-remove"></span> Sair da área do aluno
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <sidebar />
    <router-view></router-view>
  </div>
</template>
<style lang="scss" scoped>
</style>


<script>
import axios from "axios";
import Alert from "./Alert.vue";
import Sidebar from "./Sidebar.vue";

export default {
  data() {
    return {
      userName: this.$store.getters.user.name,
      menuOpen: false
    };
  },
  components: {
    alert: Alert,
    sidebar: Sidebar
  },
  methods: {
    loadUserPage() {
      console.log("change_user_edit", this.$store.getters.user)
      this.$store.commit("change_user_edit", this.$store.getters.user);
      this.$router.push({ name: "edituser", params: { previous: 'dashboard' } });
    },
    logout() {
      const path = this.$global.endpoint + "/user/logout";
      axios
        .get(path)
        .then(res => {
          this.$store.commit("reset_state");
          this.$router.push("/");
        })
        .catch(error => {
          console.error(error);
        });
    },
    toggleDropdown: function() {
      this.menuOpen = !this.menuOpen;
    },
    toggleSidebar: function() {
      const el = document.body;

      if (el.classList.contains("close-sidebar")) {
        el.classList.remove("close-sidebar");
      } else {
        el.classList.add("close-sidebar");
      }
    }
  },
  created() {}
};
</script>
